import React from 'react';
import { Heart } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useShop } from '../../context/ShopContext';

const ProductCard = ({ product, onWishlistToggle, relatedProducts = [] }) => {
  const { toggleWishlist, isInWishlist } = useShop();
  const price = typeof product.price === 'number' ? product.price : Number(product.price) || 0;
  const minPrice = typeof product.minPrice === 'number' ? product.minPrice : price;
  const maxPrice = typeof product.maxPrice === 'number' ? product.maxPrice : minPrice;
  const currency = product.currency || '€';
  const priceLabel = minPrice !== maxPrice
    ? `${currency}${minPrice.toFixed(2)} - ${currency}${maxPrice.toFixed(2)}`
    : `${currency}${minPrice.toFixed(2)}`;
  const imageSrc = product.image || (product.imageUrls && product.imageUrls[0]) || 'https://via.placeholder.com/400x400?text=No+Image';
  const productName = product.name || product.title || 'Produkti';
  const productBrand = product.brand || 'Brand i panjohur';
  const productId = product.id || product.productCode;
  const productLink = productId ? `/products/${encodeURIComponent(productId)}` : '/products';
  const isWishlisted = isInWishlist(productId);

  const handleWishlistClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
    toggleWishlist(product);
    if (typeof onWishlistToggle === 'function') {
      onWishlistToggle(product, !isWishlisted);
    }
  };

  return (
    <Link to={productLink} state={{ product, productsList: relatedProducts }}>
    <div className="group relative  rounded-md overflow-hidden hover:shadow-md transition-shadow duration-300">
      <div className="relative pt-[100%] overflow-hidden">
        <img 
          src={imageSrc} 
          alt={productName}
          className="absolute inset-0 w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-300"
        />
        <button
          type="button"
          onClick={handleWishlistClick}
          className={`absolute top-3 right-3 bg-white p-1.5 rounded-full shadow-sm opacity-80 hover:opacity-100 ${
            isWishlisted ? 'text-red-500' : 'text-gray-700'
          }`}
          aria-label={isWishlisted ? 'Hiq nga dëshirat' : 'Shto te dëshirat'}
          aria-pressed={isWishlisted}
        >
          <Heart
            size={18}
            className="transition-colors"
            fill={isWishlisted ? 'currentColor' : 'none'}
          />
        </button>
      </div>
      
      <div className="p-4">
        <div className="text-sm font-medium text-gray-500 mb-1">{productBrand}</div>
        <h3 className="font-medium text-gray-800 mb-2 min-h-[40px]">{productName}</h3>
        <div className="font-bold text-lg">{priceLabel}</div>
      </div>
    </div>
    </Link>
  );
};

export default ProductCard;